import React, { useState } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/react-hooks";
import Select from "react-select";
import {
  Row, Col, Container
} from "reactstrap";

import Modal from "components/Modal/Modal";
import RegularField from "components/Field/Field";
import { StockClearFooter } from "./StockClearFooter";
import { INVENTORY_LOCATIONS_QUERY } from "./stockInputQueries";
import { httpClient } from "../../../settings/apolloClient";

const Field = styled(RegularField)`
  margin-bottom: 25px;
`;

const StockClearModal = ({
  title,
  onSubmit,
  isOpen,
  toggleModal,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const {
    data,
  } = useQuery(
    INVENTORY_LOCATIONS_QUERY, {
      fetchPolicy: "network-only",
      client: httpClient,
    }
  );

  const { inventoryLocations } = data || [];

  const onSaveEntry = () => {
    onSubmit({ id: selectedLocation.value });
  };
  return (
    <Modal
      title={title}
      isOpen={isOpen}
      toggleModal={toggleModal}
      footer={<StockClearFooter onConfirm={onSaveEntry} disabled={!selectedLocation} />}
    >
      <Container fluid>
        <Row>
          <Col>
            <Field title="Local de estoque">
              {inventoryLocations && (
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="itemSelected"
                  value={selectedLocation}
                  onChange={value => setSelectedLocation(value)}
                  options={[
                    {
                      value: "",
                      isDisabled: true
                    },
                    ...inventoryLocations
                      .sort((a, b) => a.id - b.id)
                      .map(({ id, name }) => ({ value: id, label: name }))
                  ]}
                  placeholder="Escolha um..."
                />
              )}
            </Field>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export default StockClearModal;
